import { SVGFC } from '@repo/toolkit/types'

const ArrowDownIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.5579 16.8014C11.6116 16.8637 11.6791 16.9139 11.7557 16.9482C11.8322 16.9826 11.9158 17.0002 12.0004 17C12.074 17.0004 12.147 16.9868 12.2149 16.9598C12.2828 16.9328 12.3443 16.893 12.3957 16.8428L14.648 14.6943C14.7533 14.5938 14.8125 14.4577 14.8125 14.3157C14.8125 14.1737 14.7533 14.0376 14.648 13.9371C14.5425 13.8368 14.3995 13.7805 14.2505 13.7805C14.1014 13.7805 13.9584 13.8368 13.853 13.9371L12.563 15.1736L12.563 7.53572C12.563 7.39364 12.5037 7.25738 12.3982 7.15692C12.2927 7.05645 12.1496 7.00001 12.0004 7.00001C11.8513 7.00001 11.7082 7.05645 11.6027 7.15692C11.4972 7.25738 11.4379 7.39364 11.4379 7.53572L11.4379 15.1671L10.1464 13.94C10.041 13.8399 9.89815 13.7837 9.74927 13.7837C9.60039 13.7837 9.45758 13.8399 9.35214 13.94C9.2468 14.0404 9.18763 14.1766 9.18763 14.3186C9.18763 14.4605 9.2468 14.5967 9.35214 14.6971L11.5579 16.8014Z"
        fill={color}
      />
    </svg>
  )
}

export default ArrowDownIcon
